import { Skill } from '@contact/upgrade';

import { QueryFilterModel, QuickFilterModel } from './mail-basket.model';

export enum ActionTypes {
  CHANGE_QUERY_FILTER = '[Basket] change query filter',
  CHANGE_QUICK_FILTER = '[Basket] change quick filter',
  RESET_QUERY_FILTER = '[Basket] reset query filter',
  ADD_SKILLS = '[Basket] add skills',
  CHANGE_BOOKMARK = '[Basket] change bookmark',
  CHANGE_BOOKMARK_SUCCESS = '[Basket] change bookmark success',
  CHANGE_BOOKMARK_FAIL = '[Basket] change bookmark fail',
}

export class ChangeQueryFilter {
  readonly type = ActionTypes.CHANGE_QUERY_FILTER;

  constructor(public readonly filters: Partial<QueryFilterModel>) {}
}

export class ChangeQuickFilter {
  readonly type = ActionTypes.CHANGE_QUICK_FILTER;

  constructor(public readonly quickFilters: Partial<QuickFilterModel>) {}
}

export class ResetQueryFilter {
  readonly type = ActionTypes.RESET_QUERY_FILTER;
}

export class AddSkills {
  readonly type = ActionTypes.ADD_SKILLS;

  constructor(public readonly skills: Skill[]) {}
}

export class ChangeBookmark {
  readonly type = ActionTypes.CHANGE_BOOKMARK;

  constructor(public requestId: string, public bookmark: boolean) {}
}

export class ChangeBookmarkSuccess {
  readonly type = ActionTypes.CHANGE_BOOKMARK_SUCCESS;

  constructor(public requestId: string, public bookmark: boolean) {}
}

export class ChangeBookmarkFail {
  readonly type = ActionTypes.CHANGE_BOOKMARK_FAIL;

  constructor(public requestId: string, public bookmark: boolean, public error: string) {}
}

export type ActionsUnion =
  | ChangeQueryFilter
  | ChangeQuickFilter
  | ResetQueryFilter
  | AddSkills
  | ChangeBookmark
  | ChangeBookmarkSuccess
  | ChangeBookmarkFail;
